export default "Få gang i kroppen og styrk fællesskabet med sæljagt-legen. Kan jægeren mon ramme de legesyge sæler, der boltrer sig i havet?";